module.exports = __webpack_public_path__ + "img/infrasel-logo-white.d3e50a58.png";